const MapLayerIcon = {
  PLAIN_VESSEL: {
    HIGHLIGHTED: 'plain-vessel-highlighted',
    NORMAL: 'plain-vessel',
    ALERT: 'alert',
    BORDER: 'border',
    NEARBY: 'nearby',
  },
  RI_VESSEL: {
    HIGHLIGHTED: 'ri-vessel-highlighted',
    NORMAL: 'ri-vessel',
  },
  INCIDENT: {
    DEFAULT: 'incident-default-marker',
    SELECTED: 'incident-default-marker-alert',
  },
  MARITIME_INCIDENT: {
    DEFAULT: 'maritime-incident-default',
    BOARDING_ATTEMPTED_ROBBERY: 'maritime-incident-boarding-attempted-robbery',
    HIJACK_KIDNAPPING: 'maritime-incident-hijack-kidnapping',
    MILITARY_ACTIVITY_DAMAGE: 'maritime-incident-military-activity-damage',
    MOTIVE_UNCLEAR_PIRACY: 'maritime-incident-motive-unclear-piracy',
    ROBBERY: 'maritime-incident-robbery',
    SUSPICIOUS_APPROACH_ATTEMPTED:
      'maritime-incident-suspicious-approach-attempted',
    WARNING: 'maritime-incident-warning',
  },
  PORT: {
    DEFAULT: 'port-icon',
    DEFAULT_RI: 'port-icon-ri',
    SELECTED: 'port-icon-selected',
    SELECTED_RI: 'port-icon-selected-ri',
    INLAND_RI: 'port-inland-ri',
    CRUISE_RI: 'port-cruise-ri',
    SELECTED_CRUISE_RI: 'port-cruise-selected-ri',
  },
  HISTORIC_POSITION: 'historic-position',
  HISTORIC_MERGED_POSITION: 'historic-merged-position',
  HISTORIC_DRAUGHT_CHANGE_INCREASE: 'historic-draught-change-increase',
  HISTORIC_DRAUGHT_CHANGE_DECREASE: 'historic-draught-change-decrease',
  HISTORIC_POSITION_ALERT_TRIGGER: 'historic-position-alert-trigger',
  NOTIFICATION_TRIGGER_POSITION: 'notification-trigger-position',
  SELECTION_BRACKETS: 'selection-brackets',
  WEATHER: {
    PIN: 'weather-pin',
  },
  VESSEL_SEARCH_AREA: {
    NORMAL: 'vessel-search-area-normal',
    AMBER: 'vessel-search-area-amber',
    ALERT: 'vessel-search-area-alert',
  },
  GLOBAL_AIS: {
    FISHING_NET: 'global-ais-vessel-fishing-net',
    DEFAULT: 'global-ais-vessel-default',
    STATIC: 'global-ais-vessel-default-static',
    BUOY: 'global-ais-vessel-buoy',
  },
};

export default MapLayerIcon;
